<template>
  <div>
    <datepicker :value="date" :inline="true"></datepicker>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  data() {
    return {
      date: new Date(),
      format: "MM/dd/yyyy",
      format2: "MMMM yyyy",
      disabledDates: {
        days: [6, 0],
      },
    };
  },
  components: {
    Datepicker,
  },
};
</script>
